import { useState } from 'react';

const useSyncPageWithSessionStorage = () => {
  const [storedPage, setStoredPage] = useState<any>(
    JSON.parse(localStorage.getItem('lastPage') || '{}')?.lastPage ?? 0
  );

  const resetSavedPage = () => {
    localStorage.removeItem('lastPage');
    setStoredPage(null);
  };

  // Returning nothing as this hook is only for side effects
  return {
    savedPage: storedPage,
    resetSavedPage
  };
};

export default useSyncPageWithSessionStorage;
